import { render, staticRenderFns } from "./top-brands.vue?vue&type=template&id=5c1d08c2&"
import script from "./top-brands.vue?vue&type=script&lang=js&"
export * from "./top-brands.vue?vue&type=script&lang=js&"
import style0 from "./top-brands.vue?vue&type=style&index=0&id=5c1d08c2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports